import React, { useState,useEffect } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import SalesOrderSearchResult from "./OMSalesOrderSearchResult";
import SalesOrdersFilters from "./SalesOrdersFilters";
import { FillFilters, GetFormatedDateWithTime } from '../../../../../common/Utils'
import DataSource from "devextreme/data/data_source";
const SalesOrders = (props) => {
    const orderStatus = '0';
    const getSalesOrderUrl = "om/SaleOrder/OMSalesOrderSearch";
    const [dataSource, setDataSource] = useState(null);
    var accessToken = props.oidc.user.access_token;
    const GetOMSalesOrderGridData = (accessToken, url, formFields, OrderStatus) => {
        const enrichedFormFields = {
            ...formFields,
            ShippingDateFrom: GetFormatedDateWithTime(formFields.ShippingDateFrom),
            ShippingDateTo: GetFormatedDateWithTime(formFields.ShippingDateTo),
            OrderDateFrom: GetFormatedDateWithTime(formFields.OrderDateFrom),
            OrderDateTo: GetFormatedDateWithTime(formFields.OrderDateTo),
          };
        const store = createStore({
            key: 'rowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            loadParams: enrichedFormFields,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        dataSource.sort([
            { selector: 'keysequence', desc: false },
        ]);
        return dataSource;
    };
    const searchData = (formFields) => {
        let resultData = GetOMSalesOrderGridData(accessToken, getSalesOrderUrl, formFields, orderStatus);
        const excludedKeys = ['IDTYPE', 'ShippingDateFrom', 'ShippingDateTo', 'OrderDateFrom', 'OrderDateTo'];
        const filteredFormFields = Object.fromEntries(
            Object.entries(formFields).filter(([key]) => !excludedKeys.includes(key))
        );
        const filters = FillFilters(filteredFormFields);
        if (filters && filters.length > 0) {
            resultData.filter(filters);
        }
        setDataSource(resultData);
    };

 
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <SalesOrdersFilters searchData={searchData} />
                        <SalesOrderSearchResult data={dataSource} />
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(SalesOrders);